<template>
	<div class="header_box p_flex">
		<div class="p_flex p_login p_f_a">
			<span class="p_m_l_30 type_size_18 ">名称</span>
			<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="name" placeholder="请输入名称" @change="gets"></el-input></div>
		</div>
		<div class="p_login p_flex p_f_a p_m_l_30">
			<span class="p_m_l_20 type_size_18">年级</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20">
				<el-select class="p_flex"  v-model="gradeTypes" placeholder="请选择" @change="gets">
					<el-option v-for="item in gradeLists" :disabled="disab" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
		</div>
		<div class="p_login p_flex p_f_a p_m_l_30">
			<span class="p_m_l_20 type_size_18">学科</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20">
				<el-select class="p_flex" v-model="subjectTypes" placeholder="请选择" @change="gets">
					<el-option v-for="item in subjectLists" :disabled="disab" :key="item.id" :label="item.name" :value="item.id" ></el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Layout',
	data() {
		return {
			name: '',
			gradeTypes: "",
			gradeLists: [],
			subjectTypes: "",
			subjectLists: [],
			disab:false
		};
	},
	created() {
		// console.log(this.$route.query.js)
		if( this.$route.query.js ){
			this.disab = true
		}
		if(this.$route.query.js){
			var ojbk=this.$route.query.js.split("|")    //分割完返回过来后是一个数组
			// console.log(ojbk)
			this.$request.ajax(this).post("/api_teacher/question_list",{
				ids:ojbk
			}).then(res=>{
				// console.log(res)
				this.name=this.$route.query.ooo
				this.gradeTypes=res.data.list[0].grade
				this.subjectTypes=res.data.list[0].subject
			})
		}
		this.$request.ajax(this).post("/Library/grade").then(res=>{  //年纪
			// console.log(res)
			this.gradeLists=res.data
		})
		this.$request.ajax(this).post("/Library/subject").then(res=>{
			// console.log(res)
			this.subjectLists=res.data
		})
		if(this.$route.query.jkh && this.$route.query.hjs){
				this.name=this.$route.query.ccc
				this.gradeTypes=parseInt(this.$route.query.jkh)
				this.subjectTypes=parseInt(this.$route.query.hjs)
		}
	},
	methods: {
		gets(){
			// console.log(this.name)
			// console.log(this.gradeTypes)
			// console.log(this.subjectTypes)
			this.$emit('namwe',this.name,this.gradeTypes,this.subjectTypes)
		}
	}
};
</script>
<style lang="scss" scoped>
.button{
	width: 100px;
	margin:10px 0 10px 20px;
}
.header_box {
	padding: 20px 60px;
	background-color: #ffffff;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
.p_login {
	flex: 1;
}
>>>.el-select{
	
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/exerciseHeader.vue